import { render, staticRenderFns } from "./GiftModalItem.vue?vue&type=template&id=6f684a3c&scoped=true&"
import script from "./GiftModalItem.vue?vue&type=script&lang=js&"
export * from "./GiftModalItem.vue?vue&type=script&lang=js&"
import style0 from "./GiftModalItem.vue?vue&type=style&index=0&id=6f684a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f684a3c",
  null
  
)

export default component.exports